import { render, staticRenderFns } from "./AppHubUserMenu.vue?vue&type=template&id=60a8fd4e&scoped=true&"
import script from "./AppHubUserMenu.vue?vue&type=script&lang=js&"
export * from "./AppHubUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppHubUserMenu.vue?vue&type=style&index=0&id=60a8fd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a8fd4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
